var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 2.92735C5.0544 2.92735 2.66659 5.30253 2.66659 8.23247C2.66659 11.1624 5.0544 13.5376 7.99992 13.5376C10.9454 13.5376 13.3333 11.1624 13.3333 8.23247C13.3333 5.30253 10.9454 2.92735 7.99992 2.92735ZM1.33325 8.23247C1.33325 4.57005 4.31802 1.60107 7.99992 1.60107C11.6818 1.60107 14.6666 4.57005 14.6666 8.23247C14.6666 11.8949 11.6818 14.8639 7.99992 14.8639C4.31802 14.8639 1.33325 11.8949 1.33325 8.23247Z",
    fill: "#FF865C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4951 8.33649C11.4951 8.70273 11.1966 8.99963 10.8284 8.99963H7.72386C7.35567 8.99963 7.05719 8.70273 7.05719 8.33649L7.05719 5.79771C7.05719 5.43147 7.35567 5.13457 7.72386 5.13457C8.09205 5.13457 8.39052 5.43147 8.39052 5.79771L8.39052 7.67335L10.8284 7.67335C11.1966 7.67335 11.4951 7.97025 11.4951 8.33649Z",
    fill: "#FF865C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.fd073442a37102313514ffce63df416f.svg";
export { ForwardRef as ReactComponent };